import { memo, ReactNode } from 'react'
import { Typography } from '@mui/material'
import type { SxProps, Theme } from '@mui/material/styles'

type Props = {
    children: ReactNode
    sx?: SxProps<Theme>
}

/** Uppercase group label used across the sidebar tabs. */
const SectionLabel = ({ children, sx }: Props) => (
    <Typography
        variant="caption"
        color="text.tertiary"
        sx={[
            { display: 'block', mb: 1, textTransform: 'uppercase', letterSpacing: '0.08em', fontWeight: 500 },
            ...(Array.isArray(sx) ? sx : [sx])
        ]}
    >
        {children}
    </Typography>
)

export default memo(SectionLabel)
